import type { CursorPage } from '@mira/clients-shared';

export function page<T>(items: T[]): CursorPage<T> {
  return { items };
}

export function formatDateLabel(value?: string | null): string {
  if (!value) return 'Recent';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Recent';
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(date);
}

export function safeDisplayName(me: unknown, fallback = 'Mira account'): string {
  const profile = objectValue(me, 'profile');
  const user = objectValue(me, 'user');
  return (
    cleanDisplayName(stringValue(profile, 'displayName')) ||
    cleanDisplayName(stringValue(profile, 'display_name')) ||
    cleanDisplayName(stringValue(user, 'displayName')) ||
    cleanDisplayName(stringValue(user, 'display_name')) ||
    cleanDisplayName(stringValue(user, 'username')) ||
    fallback
  );
}

function cleanDisplayName(value: string): string {
  const text = value.trim();
  if (!text || text.includes('@')) return '';
  if (text.length <= 24) return text;
  const firstWord = text.split(/\s+/u)[0] || '';
  return firstWord.length <= 18 ? firstWord : '';
}

function objectValue(source: unknown, key: string): Record<string, unknown> | null {
  if (!source || typeof source !== 'object' || !(key in source)) return null;
  const value = (source as Record<string, unknown>)[key];
  return value && typeof value === 'object' ? value as Record<string, unknown> : null;
}

function stringValue(source: Record<string, unknown> | null, key: string): string {
  const value = source?.[key];
  return typeof value === 'string' ? value : '';
}
